export default __webpack_public_path__ + "static/media/break.76e8ab8c.png";